import GenericDB from './generic-db';

export default class AssessmentTypesDB extends GenericDB {
  constructor() {
    super('assessmentTypes');
  }
}
